// extracted by mini-css-extract-plugin
module.exports = {"root":"carousel_root__hWnoK"};